import { API_REQUEST, GET_AMP_STATUS } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const getAmpStatus = (): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/status-message`,
        next: GET_AMP_STATUS,
        method: 'GET',
        authorization: false
    }
});
